import { isInitialCredentialResponse } from '@urbanik/api-contracts';
export async function issueInitialCredential(baseUrl, userId) {
    const r = await fetch(baseUrl.replace(/\/$/, '') + '/identity/users/' + encodeURIComponent(userId) + '/credential', { method: 'POST', credentials: 'include', headers: { Accept: 'application/json' } });
    const b = await r.json();
    if (!r.ok)
        throw new Error(b.message ?? 'No se pudo generar la credencial.');
    if (!isInitialCredentialResponse(b))
        throw new Error('La credencial recibida no es válida.');
    return b;
}
export async function changeOwnPassword(baseUrl, input) {
    const r = await fetch(baseUrl.replace(/\/$/, '') + '/identity/password/change', {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    const b = (await r.json().catch(() => null));
    if (!r.ok)
        throw new Error(b?.message ?? 'No se pudo cambiar la contraseña.');
    return true;
}
